import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from '@ag-grid-community/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxEditorModule } from 'ngx-editor';
import { DocumentsComponent } from './components/documents/documents.component';
import { UsersComponent } from './components/users/users.component';
import { CreateUserComponent } from './components/users/create-user/create-user.component';
import { EmailUsersComponent } from './components/email-users/email-users.component';
import { GenerateListComponent } from './components/email-users/generate-list/generate-list.component';
import { EditUserComponent } from './components/users/edit-user/edit-user.component';
import { AdminRoutingModule } from './admin-routing.module';
import { ViewerModule } from '@dexio/common';

import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ProjectsComponent } from './components/projects/projects.component';
import { MessagesComponent } from './components/messages/messages.component';
import { MatCardModule } from '@angular/material/card';
import { CsvExportModule } from '@ag-grid-community/csv-export';

ModuleRegistry.registerModules([ ClientSideRowModelModule, CsvExportModule ]);

@NgModule({
  declarations: [
    UsersComponent,
    DocumentsComponent,
    CreateUserComponent,
    EditUserComponent,
    EmailUsersComponent,
    GenerateListComponent,
    ProjectsComponent,
    MessagesComponent
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    AgGridModule,
    FormsModule,
    ReactiveFormsModule,
    NgxEditorModule,
    ViewerModule,
    MatCardModule,
  ],
  exports: [
    UsersComponent
  ]
})
export class AdminModule { }
